<template lang="pug">
div.container-banner
  .img
    img( src="@/assets/bannerLogo/money-footrest.svg" )
  .text
    div.text-header.text-32 Привет! Я — Беллик
    div.mt-8.text-body.text-20 Вместе мы накопим на мечту и научимся управлять своими деньгами! 
    div.education.text-15 Перед началом — короткое обучение
    div.button-container
      button.button.cancel( @click="goToMainPage" ) Пропустить
      button.button.next.ml-6( @click="startEducation") Начать обучение
</template>

<script>

export default {
  name: 'StartPage',

  methods: {
    startEducation() {
      this.$router.push({path: '/educationpage'})
    },

    goToMainPage() {
      this.$router.push({path: '/home'})
    }
  }
}
</script>
<style scoped>
.container-banner {
  background: #FFEF9E;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.img {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: 10px 0;
}

.img img {
  max-height: 40vh;
  max-width: 90%;
  object-fit: contain;
}
.text {
  background: #FFFFFF;
  border-top-left-radius: 120px;
  border-top-right-radius: 120px;
  padding: 40px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-header {
  text-align: center;
}
.text-body {
  margin-top: 12px;
  text-align: center;
}
.education {
  margin-top: 34px;
  color: #5365E5;
}
.button-container {
  margin-top: 20px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  padding-right: 20px;
  padding-left: 20px;
  justify-content: center;
}
button {
  height: 78px;
  width: 160px;
  border-radius: 60px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.cancel {
  background: #FDF1F1;
  color: #F6514C;
}
.next {
  color: #FFFFFF;
  background: #F6514C;
}
</style>
